import React, { Component } from 'react'
import { FaChevronDown } from 'react-icons/fa'
import ProductListDetails from '../ProductListDetails'
import SidePanel from '../SidePanel'
import './index.css'

const sortOptions = [
  'NEWEST FIRST',
  'POPULAR',
  'PRICE: HIGH TO LOW',
  'PRICE: LOW TO HIGH',
]

class FilterRecommand extends Component {
  state = {
    isDropdownOpen: false,
    selectedSort: 'NEWEST FIRST',
    productsList: [],
    sidebar: false,
  }

  componentDidMount() {
    const { products } = this.props
    this.setState({ productsList: products })
  }

  toggleDropdown = () => {
    this.setState(prev => ({ isDropdownOpen: !prev.isDropdownOpen }))
  }

  toggleSidebar = () => {
    this.setState(prev => ({ sidebar: !prev.sidebar }))
  }

  sortProducts = selected => {
    const { productsList } = this.state
    const sortedList = [...productsList]

   


    switch (selected) {
      case 'PRICE: LOW TO HIGH':
        sortedList.sort((a, b) => a.price - b.price)
        break
      case 'PRICE: HIGH TO LOW':
        sortedList.sort((a, b) => b.price - a.price)
        break
      case 'POPULAR':
        sortedList.sort((a, b) => b.rating.count - a.rating.count)
        break
      default:
        sortedList.sort((a, b) => b.id - a.id) 
    }

    this.setState({
      selectedSort: selected,
      isDropdownOpen: false,
      productsList: sortedList,
    })
  }

  render() {
    const { isDropdownOpen, selectedSort, productsList, sidebar } = this.state

    return (
      <div className="filter-wrapper">
        {/* Header Bar */}
        <div className="filter-header">
          <div className="filter-left">
            <p className="item-count">{productsList.length} ITEMS</p>
            <p
              onClick={this.toggleSidebar}
              className={sidebar ? 'toggle-btn hide' : 'toggle-btn show'}
            >
              {sidebar ? 'HIDE FILTER' : 'SHOW FILTER'}
            </p>
          </div>

          <div className="filter-right">
            <p className="sort-label">{selectedSort}</p>
            <FaChevronDown
              onClick={this.toggleDropdown}
              className="dropdown-icon"
            />
            {isDropdownOpen && (
              <ul className="dropdown-menu">
                {sortOptions.map(option => (
                  <li key={option} onClick={() => this.sortProducts(option)}>
                    {option}
                  </li>
                ))}
              </ul>
            )}
          </div>
        </div>

        {/* Sidebar + Products */}
        <div className="content-area">
          {sidebar && (
            <div className="sidebar">
              <SidePanel />
            </div>
          )}

          <ul className="products-list">
            {productsList.map(product => (
              <ProductListDetails key={product.id} productDetails={product} />
            ))}
          </ul>
        </div>
      </div>
    )
  }
}

export default FilterRecommand


